import { render, staticRenderFns } from "./UpdateAvailability.vue?vue&type=template&id=bdaa7de2"
import script from "./UpdateAvailability.vue?vue&type=script&lang=ts"
export * from "./UpdateAvailability.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports